const chargerTypes = [
  { value: 'I', label: 'I' },
  { value: 'II', label: 'II' },
  { value: 'III', label: 'III' },
  { value: 'DC', label: 'DC' },
];

export default chargerTypes;
